/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The IntegrationsashWellnessAshWellnessIntegration1 model module.
 * @module model/IntegrationsashWellnessAshWellnessIntegration1
 * @version v0.3
 */
export default class IntegrationsashWellnessAshWellnessIntegration1 {
  /**
   * Constructs a new <code>IntegrationsashWellnessAshWellnessIntegration1</code>.
   * @alias module:model/IntegrationsashWellnessAshWellnessIntegration1
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IntegrationsashWellnessAshWellnessIntegration1</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationsashWellnessAshWellnessIntegration1} obj Optional instance to populate.
   * @return {module:model/IntegrationsashWellnessAshWellnessIntegration1} The populated <code>IntegrationsashWellnessAshWellnessIntegration1</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationsashWellnessAshWellnessIntegration1();
      if (data.hasOwnProperty('partner_id'))
        obj.partnerId = ApiClient.convertToType(data['partner_id'], 'String');
      if (data.hasOwnProperty('access_token'))
        obj.accessToken = ApiClient.convertToType(data['access_token'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {String} partnerId
 */
IntegrationsashWellnessAshWellnessIntegration1.prototype.partnerId = undefined;

/**
 * @member {String} accessToken
 */
IntegrationsashWellnessAshWellnessIntegration1.prototype.accessToken = undefined;

/**
 * @member {Boolean} enabled
 */
IntegrationsashWellnessAshWellnessIntegration1.prototype.enabled = undefined;

